import { AnyObject } from '@apeiron/temp'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakeBuyDailyCheckInShopItem = (): Hook => {
  const makeBuyResult = useCallback((input: AnyObject): boolean => {
    return R.propOr(false, 'isPurchaseSuccess', input)
  }, [])

  return {
    makeBuyResult
  }
}

type Hook = {
  makeBuyResult: (input: AnyObject) => boolean
}

export default useMakeBuyDailyCheckInShopItem
